export const getCulture = (language?: string) => {
  switch (language) {
    case 'de':
    case 'fr':
    case 'it':
      return language + '-CH';

    default:
      return language;
  }
};
